import { render, staticRenderFns } from "./SSOCallback.vue?vue&type=template&id=39c4d6f4"
import script from "./SSOCallback.vue?vue&type=script&lang=js"
export * from "./SSOCallback.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports